import { SKTCheckbox } from "./SKTCheckbox";
import { SKTToggle } from "./SKTToggle";
import { SKTInfo } from "./SKTInfo";
import { SKTUnitField } from "./SKTUnitField";
import { SKTDimensions, SKTIndexedDimensions } from "./SKTDimensions";
import { Fragment, useState } from "react";
import { range } from "../utils/range";
import { SKTRadioButton, SKTRadioOption } from "./SKTRadioButton";

const SKTParcel = ({ data, index }) => {
  console.log(index);
  return (
    <Fragment>
      <SKTUnitField
        data={data}
        id={`iPWeight${index}`}
        label={`Kollin ${index} paino`}
        placeholder="100"
        unit="kg"
      />
      <SKTIndexedDimensions index={index} data={data} />
    </Fragment>
  );
};

const SKTPallet = ({ data, index }) => {
  return (
    <Fragment>
      <SKTUnitField
        data={data}
        id={`iPWeight${index}`}
        label={`Kollin ${index} paino`}
        placeholder="100"
        unit="kg"
      />
      <SKTRadioButton
        data={data}
        id={`iPPalletType${index}`}
        label={`Kollin ${index} laji`}
        singleValue={true}
      >
        <SKTRadioOption
          data={data}
          id={`iPPalletType${index}`}
          value="EURPALLET"
          label="EURO-lava"
        />
        <SKTRadioOption
          data={data}
          id={`iPPalletType${index}`}
          value="FINPALLET"
          label="FIN-lava"
        />
        <SKTRadioOption
          data={data}
          id={`iPPalletType${index}`}
          value="HALFPALLET"
          label="TEHO-lava"
        />
      </SKTRadioButton>
      <SKTUnitField
        data={data}
        id={`iPHeight${index}`}
        label={`Kollin ${index} korkeus`}
        placeholder="180"
        unit="cm"
      />
    </Fragment>
  );
};

const SKTParcels = ({ data }) => {
  const parcelCount = () => {
    try {
      const numParcel = parseInt(data.get("iPParcel"));
      if (numParcel < 1) return 1;
      if (numParcel > 20) return 20;
      return numParcel;
    } catch (error) {
      return 1;
    }
  };
  return (
    <Fragment>
      <SKTUnitField
        data={data}
        id="iPParcel"
        label="Kollien lukumäärä"
        placeholder="1"
        unit="kpl"
      />
      {range(parcelCount(), 1).map((index) => {
        return (
          <SKTParcel
            key={index}
            data={data}
            idPrefix="iPParcel"
            index={index}
          />
        );
      })}
    </Fragment>
  );
};

const SKTPallets = ({ data }) => {
  const parcelCount = () => {
    try {
      const numParcel = parseInt(data.get("iPParcel"));
      if (numParcel < 1) return 1;
      if (numParcel > 20) return 20;
      return numParcel;
    } catch (error) {
      return 1;
    }
  };
  return (
    <Fragment>
      <SKTUnitField
        data={data}
        id="iPParcel"
        label="Kollien lukumäärä"
        placeholder="1"
        unit="kpl"
      />
      {range(parcelCount(), 1).map((index) => {
        return (
          <SKTPallet
            key={index}
            data={data}
            idPrefix="iPPallet"
            index={index}
          />
        );
      })}
    </Fragment>
  );
};

export const SKTShipment = ({ data }) => {
  return (
    <Fragment>
      <SKTToggle when={data.get("mode") === "corporate"}>
        <SKTCheckbox
          data={data}
          id="iPPallets"
          label="Haluan lähettää lavoja"
        />
      </SKTToggle>
      <SKTToggle when={!data.get("iPPallets")}>
        <SKTInfo>
          Syötä alle kuljetuksen paino ja mitat. Mikäli kuljetus koostuu
          useammasta kappaleesta, anna jokaisen kappaleen mitat erikseen.
        </SKTInfo>
      </SKTToggle>
      <SKTToggle when={data.get("iPPallets")}>
        <SKTInfo>
          Mikäli kuljetus koostuu useammasta kappaleesta, anna jokaisen
          kappaleen paino ja lavan tyyppi erikseen
        </SKTInfo>
      </SKTToggle>

      <SKTToggle when={data.get("iPPallets")}>
        <SKTPallets data={data} />
        <SKTToggle when={false}>
          <SKTUnitField
            data={data}
            id="iPEUR"
            label="EURO-lavat"
            placeholder="0"
            unit="kpl"
            corporate="1"
          />
          <SKTUnitField
            data={data}
            id="iPFIN"
            label="FIN-lavat"
            placeholder="0"
            unit="kpl"
            corporate="1"
          />
          <SKTUnitField
            data={data}
            id="iPTEHO"
            label="TEHO-lavat"
            placeholder="0"
            unit="kpl"
            corporate="1"
          />
        </SKTToggle>
      </SKTToggle>
      <SKTToggle when={!data.get("iPPallets")}>
        <SKTToggle when={false}>
          <SKTDimensions data={data} />
          <SKTUnitField
            data={data}
            id="iPParcel"
            label="Kollien lukumäärä"
            placeholder="1"
            unit="kpl"
          />
        </SKTToggle>
        <SKTParcels data={data} />
        <SKTToggle when={data.get("mode") === "corporate"}>
          <SKTCheckbox
            data={data}
            id="on_top"
            label="Lähetys on malliltaan ja pakkaukseltaan sellainen, että päälle voidaan lastata painonsa verran kuormaa"
          />
        </SKTToggle>
      </SKTToggle>
    </Fragment>
  );
};
